export default __webpack_public_path__ + "static/media/slide4.8e58ee5f.jpg";